import { render, staticRenderFns } from "./CoachCard.vue?vue&type=template&id=77f4511e&"
import script from "./CoachCard.vue?vue&type=script&lang=js&"
export * from "./CoachCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports